const phrases = [
  "Comprender para avanzar",
  "Atención individualizada",
  "Chiclana de la Frontera",
  "Acompañamiento a familias",
  "Estrategias de aprendizaje",
  "Orientación académica",
];

const Row = ({ ariaHidden }) => (
  <div
    aria-hidden={ariaHidden}
    className="flex shrink-0 items-center"
  >
    {phrases.map((p, i) => (
      <span key={i} className="flex items-center">
        <span className="font-serif italic text-2xl sm:text-3xl text-ivory/90 whitespace-nowrap px-8">
          {p}
        </span>
        <span className="w-1.5 h-1.5 rotate-45 bg-sage shrink-0" aria-hidden="true" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="marquee-paused relative overflow-hidden bg-atento-blue py-6 sm:py-7 select-none"
    >
      <div className="animate-marquee flex w-max">
        <Row ariaHidden={false} />
        <Row ariaHidden={true} />
      </div>
    </div>
  );
}
